import { gql } from "@apollo/client";

export const BUILDING_LIST_QUERY = gql`
  query GetBuildings($limit: Int = 10, $offset: Int = 0) {
    Building(
      where: { isActive: { _eq: true } }
      limit: $limit
      offset: $offset
      order_by: { BuildingName: asc }
    ) {
      BuildingName
      Id
      CampusId
      LastUpdateDateTime
      centerLat
      centerLong
    }
    Building_aggregate(where: { isActive: { _eq: true } }) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_FLOOR_OVERLAYS = gql`
  query GetFloorOverlays($buildingId: uuid = "") {
  FloorOverlay(where: {BuildingId: {_eq: $buildingId}}, order_by: {FloorNumber: asc}) {
    BuildingId
    CenterLat
    CenterLng
    D_diff
    FloorNumber
    Id
    ImageUrl
    Name
    Rot
    created_at
    k_diff
    updated_at
  }
}
`;

export const GET_FLOOR_OVERLAYS_ANDROID = gql`
  query GetFloorOverlaysAndroid($buildingId: uuid = "") {
    FloorOverlay(where: { BuildingId: { _eq: $buildingId } }) {
      BuildingId
      CenterLat
      CenterLng
      D_diff
      FloorNumber
      Id
      ImageUrl
      Name
      Rot
      created_at
      k_diff
      updated_at
      AndroidFloors {
        Id
        buildingId
        floorOverlayId
        created_at
        isActive
        name
        northWestLat
        northWestLng
        number
        rotation
        southEastLat
        southEastLng
        updated_at
      }
    }
  }
`;

export const GET_SHIFT_CONFIGS = gql`
  query GetShiftConfigs($buildingId: uuid) {
    ShiftConfig(
      where: { isActive: { _eq: true }, buildingId: { _eq: $buildingId } }
      order_by: { startTime: asc }
    ) {
      Id
      buildingId
      endTime
      startTime
      title
      number
    }
  }
`;

export const GET_SHIFTS_BY_DATE = gql`
query GetShiftsByDate($buildingId: uuid, $_gte: timestamptz) {
    Shift(
      where: {
        buildingId: { _eq: $buildingId }
        _and: { StartDateTime: { _gte: $_gte } }
      }
      order_by: { StartDateTime: asc }
      limit: 4
    ) {
      Id
      Description
    }
  }
`
